//import Container from 'typedi';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import showAlert from '../alert/alertHandler';
import RecursiveSelector from '@/components/RecursiveSelector';
import responseCodeManager from '../utils/responseCodeManager.js';
import { checkForm, getPopoverData, hidePopover } from '../utils/formValidator.js';
import { canUserAccess, hasPermission } from '../utils/userAcces.js';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import BuscadorDirecciones from '@/components/global/buscador-direcciones/buscador-direcciones.vue';
import SimpleMap from '@/components/global/simple-map/SimpleMap.vue';
import XLSX from 'xlsx';
import showConfirmation from '../confirmation/confirmationHandler';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import spotForm from '../components/SpotForm.vue';

import vehicleEscl from '../locales/es-CL/vehicle.json';
import vehicleEsmx from '../locales/es-MX/vehicle.json';
import vehicleEsco from '../locales/es-CO/vehicle.json';
import vehicleEnus from '../locales/en-US/vehicle.json';
import vehicleTypeEscl from '../locales/es-CL/vehicleType.json';
import vehicleTypeEsmx from '../locales/es-MX/vehicleType.json';
import vehicleTypeEsco from '../locales/es-CO/vehicleType.json';
import vehicleTypeEnus from '../locales/en-US/vehicleType.json';
import vehicleCrudModal from '../vehicle/vehicleModal/vehicleModalHandler';

import LogService from '../services/LogService';
import Container from 'typedi';

import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
  name: 'Vehiculo',
  components: {
    Multiselect,
    RecursiveSelector,
    VueCtkDateTimePicker,
    GoogleMapsApiLoader,
    BuscadorDirecciones,
    SimpleMap,
    spotForm,
  },
  i18n: {
    messages: {
      'es-CL': {
        vehicle: vehicleEscl,
        vehicleType: vehicleTypeEscl,
      },
      'es-MX': {
        vehicle: vehicleEsmx,
        vehicleType: vehicleTypeEsmx,
      },
      'es-CO': {
        vehicle: vehicleEsco,
        vehicleType: vehicleTypeEsco,
      },
      'en-US': {
        vehicle: vehicleEnus,
        vehicleType: vehicleTypeEnus,
      },
    },
  },
  data() {
    return {
      rowsExcelTranform: [],
      optionsSpots: [],
      rowsExcel: null,
      fileExcel: null,
      isMassiveActive: false,
      isCreateMode: false,
      isModuleReady: false,
      datos: [],
      downloadTemplate: false,
      isFilterShown: false,
      isFilterClicked: false,
      isFilterApplied: false,
      checkForm,
      getPopoverData,
      selectedAll: false,
      gruposSeleccionados: [],
      groupClient: [],
      valueLegalPermissionDue: '',
      valueTecnicalInspectionDue: '',
      valueFuelEconomy: '',
      dateTecnicalInspectionDue: '',
      dateLegalPermissionDue: '',
      checkedVehicle: [],
      vehiclesFilter: [],
      filterGroups: [],
      filterFleets: [],
      isLoadingType: false,
      optionsType: {
        all: 'Todos',
        types: [],
      },
      originAddressStreet: null,
      isTemporalSpotBusy: false,
      spotTypeSelected: null,
      spotTypeList: [],
      countryList: [],
      countrySelected: null,
      businessList: [],
      businessSelected: null,
      temporalSpotRequired: false,
      spotForm: {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      },
      selectedType: [],
      types: [],
      typesExtra: [],
      isLoadingClient: false,
      selectedClient: null,
      optionsClient: [],
      isLoadingGroup: false,
      selectedGroups: [],
      optionsGroup: [],
      clients: [],
      valueBrand: '',
      valueVehicleTypeExtra: [],
      valueGroups: [],
      valueFuel: '',
      valueEnable: '',
      dataBrand: [],
      dataVehicleTypeExtra: [],
      vehicleTypes: [],
      dataGroups: [],
      hierarchyGroups: [],
      dataGroupExcel: [],
      groupCellWidth: 0,
      dataStatus: [],
      dataFuel: [],
      dataEnable: [
        { name: 'Habilitado', bool: true },
        { name: 'Deshabilitado', bool: false },
      ],
      isBusy: false,
      isCrudBusy: false,
      keyword: '',
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      vehicles: [],
      detail: '',
      responseSave: '',
      selectedVehicle: '',
      createForm: {
        name: '',
        brand: '',
        vehicleType: {
          id: 1,
        },
        group: {
          id: 1998,
        },
        maxContinuousTimeDriving: null,
        maxKms: null,
        maxMoney: null,
        maxTime: null,
        maxTimeDriving: null,
        maxVisits: null,
        maxVolume: null,
        maxWeigth: null,
        plate: '',
        chasis: '',
        model: '',
        year: null,
        color: '',
        observation: '',
        status: '',
        fuel: null,
        enabled: true,
        vehicleExtra: {
          id: '',
          fuelEconomy: null,
          tecnicalInspectionDue: '',
          legalPermissionDue: '',
        },
      },
      update: 0,
      updateForm: {
        name: '',
        observation: '',
        plate: '',
        chasis: '',
        status: '',
        fuel: null,
        brand: '',
        model: '',
        year: null,
        color: '',
        enabled: true,
        vehicleType: {
          id: '',
        },
        group: {
          id: '',
        },
        vehicleExtra: {
          id: '',
          fuelEconomy: null,
          tecnicalInspectionDue: '',
          legalPermissionDue: '',
        },
      },
      parameterFields: [
        {
          id: 'name',
          min: null,
          max: 64,
          condition: ['longField'],
        },
        {
          id: 'brand',
          min: null,
          max: null,
          condition: [],
        },
        {
          id: 'vehicleTypeExtra',
          min: null,
          max: 8,
          condition: ['requireField', 'longField'],
        },
        {
          id: 'plate',
          min: null,
          max: 20,
          condition: ['requireField', 'longField'],
        },
        {
          id: 'model',
          min: null,
          max: 255,
          condition: ['longField'],
        },
        {
          id: 'chasis',
          min: null,
          max: 64,
          condition: ['longField'],
        },
        {
          id: 'color',
          min: null,
          max: 50,
          condition: ['longField'],
        },
        {
          id: 'observation',
          min: null,
          max: 255,
          condition: ['longField'],
        },
        {
          id: 'status',
          min: null,
          max: null,
          condition: ['requireField'],
        },
        {
          id: 'enabled',
          min: null,
          max: 255,
          condition: ['requireField'],
        },
      ],
      resultValidation: null,
      modeCrud: null,
      modalSave: 'save-modal',
      authPermissionVehicle: 4,
      canAccessButtonCreate: true,
      authPermissionVehicleCreate: 9,
      canAccessButtonUpdate: true,
      authPermissionVehicleUpdate: 10,
      canAccessButtonDelete: true,
      authPermissionVehicleDelete: 11,
      canAccessButtonPlate: true,
      authPermissionVehiclePlate: 16,
      dataAccess: null,
      tags: [],
      selectedTags: [],
      selectedDepot: null,
      drivers: [],
      driverVehicle: [],
      selectedDriver: null,
      typeVehicleExcel: null,
      groupSelectedExcel: null,
      typeVehicleSelectedExcel: null,
      groupsExcel: null,
      tagsExcel: null,
      brandsExcel: null,
      gapi: null,
      destinationsExcel: null,
      missRequiredData: false,
      createPreassignationOnConflict: true,
      currentTab: 'vehicle',
      //ACA PARTE LAS VARIABLES DEL VEHICLETYPE
      hidePopover,
      authSuper: false,
      noContent: false,
      selectedAllVehicleTypes: false,
      vehicleTypesSelected: [],
      dataIcon: [],
      selected: '',
      keywordType: '',
      perPageType: 10,
      currentPageType: 1,
      detailType: '',
      responseSaveType: '',
      selectedVehicletype: '',
      createFormType: {
        name: '',
        category: 1,
        icon: '',
        maxContinuousTimeDriving: 0,
        maxKms: 0,
        maxMoney: 0,
        maxTime: 0,
        maxTimeDriving: 0,
        maxVisits: 0,
        maxVolume: 0,
        maxWeigth: 0,
      },
      updateFormType: {
        id: '',
        name: '',
        category: 1,
        icon: '',
        maxContinuousTimeDriving: 0,
        maxKms: 0,
        maxMoney: 0,
        maxTime: 0,
        maxTimeDriving: 0,
        maxVisits: 0,
        maxVolume: 0,
        maxWeigth: 0,
      },
      parameterFieldsType: [
        {
          id: 'maxContinuousTimeDriving',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxKms',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxMoney',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxTime',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxTimeDriving',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxVisits',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxVolume',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'maxWeigth',
          min: 0,
          max: 9999,
          condition: ['longField', 'onlyNumberField'],
        },
        {
          id: 'name',
          min: null,
          max: 255,
          condition: ['requireField', 'longField'],
        },
        {
          id: 'icon',
          min: null,
          max: null,
          condition: ['requireField'],
        },
      ],
      logService: null,
    };
  },
  created() {
    this.logService = Container.get(LogService);
    GoogleMapsApiLoader({
      libraries: ['places'],
      apiKey: this.$store.getters.apiKey,
    }).then((google) => {
      this.gapi = google;
    });
    this.prepareData(); //TRAN-511 Cualquier variable/funcion que dependa de local storage, guardarla aqui.
  },
  mounted() {
    this.checkClient();
    this.$nextTick(() => {
      console.log('DOM actualizado después de un cambio en datos reactivos');
      // Realiza alguna acción después de una actualización del DOM
    });
  },
  updated() {
    this.$nextTick(() => {
      console.log('DOM actualizado después de un cambio en datos reactivos');
      // Realiza alguna acción después de una actualización del DOM
    });
  },
  methods: {
    async prepareData() {
      this.selectedClient = this.$store.getters.clientId;
      this.dataAccess = this.$store.getters.dataAccess;
      await this.refreshDataClient();
      await this.getSelect();
      this.isModuleReady = true;
    },
    async changeTab(navBar) {
      this.currentTab = navBar;
    },
    populateDataVehicleTypeExtraExcel() {
      console.log(this.dataVehicleTypeExtra);
      this.typeVehicleExcel = '';
      for (let i = 0; i < this.dataVehicleTypeExtra.length; i++) {
        if (i == this.dataVehicleTypeExtra.length - 1) {
          this.typeVehicleExcel += this.dataVehicleTypeExtra[i].name.trim();
          this.typeVehicleSelectedExcel = this.dataVehicleTypeExtra[i].name.trim();
          console.log('TYPEVECHICLE', this.typeVehicleExcel);
        } else {
          this.typeVehicleExcel += this.dataVehicleTypeExtra[i].name + ',';
        }
      }
    },
    populateGroupsExcel() {
      this.groupsExcel = '';
      for (let i = 0; i < this.dataGroups.length; i++) {
        if (i == this.dataGroups.length - 1) {
          this.groupsExcel += this.dataGroups[i].name;
          this.groupSelectedExcel = this.dataGroups[i].name;
          console.log('GROUPSEXCEL', this.groupsExcel);
        } else {
          this.groupsExcel += this.dataGroups[i].name + ',';
        }
      }
    },
    populateBrandExcel() {
      this.brandsExcel = '';
      for (let i = 0; i < 25; i++) {
        if (i == 24) {
          this.brandsExcel += this.dataBrand[i];
          console.log('BRAND', this.brandsExcel);
        } else {
          this.brandsExcel += this.dataBrand[i] + ',';
        }
      }
    },
    populateTagsExcel() {
      this.tagsExcel = '';
      for (let i = 0; i < this.tags.length; i++) {
        if (i == this.tags.length - 1) {
          this.tagsExcel += this.tags[i].name;
          console.log('TAGECXEL', this.tagsExcel);
        } else {
          this.tagsExcel += this.tags[i].name + ',';
        }
      }
    },
    populateDestinationsExcel() {
      this.destinationsExcel = '';
      for (let i = 0; i < this.optionsSpots.length; i++) {
        if (i == this.optionsSpots.length - 1) {
          this.destinationsExcel += this.optionsSpots[i].name;
          console.log('DESTINATIONSEXCEL', this.destinationsExcel);
        } else {
          this.destinationsExcel += this.optionsSpots[i].name + ',';
        }
      }
    },
    async buildExcelPro() {
      //Metodo que llena el dropdown del excel con datos de tipo de vehículos extra (por cliente)
      this.populateDataVehicleTypeExtraExcel();
      //this.populateGroupsExcel();
      this.populateBrandExcel();
      console.log('PRO PRO PRO VEHICLE');
      console.log(this.tags);
      this.populateTagsExcel();
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Vehiculos');

      const headers = [
        { header: 'Tipo de vehículo (Obligatorio)', key: 'tdv', width: 40 },
        //{ header: 'Grupo (Obligatorio)', key: 'gru', width: 40 },
        { header: 'Placa/patente (Obligatorio)', key: 'pla', width: 30 },
        { header: 'Nombre del vehículo', key: 'ndv', width: 30 },
        { header: 'Marca', key: 'mar', width: 30 },
        { header: 'Modelo', key: 'mod', width: 30 },
        { header: 'Vin/chasis', key: 'cha', width: 30 },
        { header: 'Color', key: 'col', width: 20 },
        { header: 'Vencimiento de revisión técnica', key: 'vrt', width: 20 },
        { header: 'Vencimiento de permiso de circulación', key: 'vpc', width: 20 },
        { header: 'Habilitado en Last Mile (Obligatorio)', key: 'hab', width: 35 },
        { header: 'Observaciones', key: 'obs', width: 40 },
        { header: 'Atributos', key: 'att', width: 25 },
      ];

      ws.columns = headers;

      ws.addRow({
        tdv: this.typeVehicleSelectedExcel,
        //gru: this.groupSelectedExcel,
        pla: '(Ejemplo) AABBCC-123',
        ndv: '(Ejemplo) Vehiculo 1',
        hab: 'Habilitado',
      });
      ws.addRow({
        tdv: this.typeVehicleSelectedExcel,
        //gru: this.groupSelectedExcel,
        pla: '(Ejemplo) AABBCC-124',
        ndv: '(Ejemplo) Vehiculo 2',
        hab: 'Habilitado',
      });

      for (let i = 0; i < this.optionsSpots.length; i++) {
        ws.getCell(`$ND$${i + 1}`).value = this.optionsSpots[i].name;
      }

      for (let i = 2; i < 200; i++) {
        if (this.typeVehicleExcel.length > 0) {
          ws.getCell(`A${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.typeVehicleExcel}"`],
          };
        }
        /* ws.getCell(`B${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: [`"${this.groupsExcel}"`],
        }; */
        if (this.brandsExcel.length > 0) {
          ws.getCell(`D${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.brandsExcel}"`],
          };
        }
        ws.getCell(`J${i}`).dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"Habilitado,Deshabilitado"'],
        };
        if (this.tagsExcel.length > 0) {
          ws.getCell(`L${i}`).dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: [`"${this.tagsExcel}"`],
          };
        }
      }

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'excel_vehiculos_masivo_template' + fileExtension);
    },
    async prepareFileExcel() {
      let typeExtra = 'Tipo de vehículo (Obligatorio)';
      let plate = 'Placa/patente (Obligatorio)';
      let name = 'Nombre del vehículo';
      let brand = 'Marca';
      let model = 'Modelo';
      let chasis = 'Vin/chasis';
      let color = 'Color';
      let tecnicalInspectionDue = 'Vencimiento de revisión técnica';
      let dateLegalPermissionDue = 'Vencimiento de permiso de circulación';
      let available = 'Habilitado en Last Mile (Obligatorio)';
      let observation = 'Observaciones';
      let tag = 'Atributos';
      let depot = 'Bodega Origen';
      for (let row of this.rowsExcel) {
        Object.entries(row).forEach((entry) => {
          const [key, value] = entry;
          if (key.trim() === typeExtra) {
            row.typeExtra = value;
          } else if (key.trim() === plate) {
            row.plate = value;
          } else if (key.trim() === name) {
            row.name = value;
          } else if (key.trim() === brand) {
            row.brand = value;
          } else if (key.trim() === model) {
            row.model = value;
          } else if (key.trim() === chasis) {
            row.chasis = value;
          } else if (key.trim() === color) {
            row.color = value;
          } else if (key.trim() === tecnicalInspectionDue) {
            row.tecnicalInspectionDue = value;
          } else if (key.trim() === dateLegalPermissionDue) {
            row.dateLegalPermissionDue = value;
          } else if (
            key.trim() === available ||
            key.trim() === 'Habilitado/Deshabilitado (Obligatorio)' ||
            key.trim() === 'Habilitado/Deshabilitado' ||
            key.trim() === 'Habilitado'
          ) {
            row.available = value;
          } else if (key.trim() === observation) {
            row.observation = value;
          } else if (key.trim() === tag) {
            row.tag = value;
          } else if (key.trim() === depot) {
            row.depot = value;
          } else {
            delete row[key];
          }
        });
      }
    },
    /**
     * Metodo que verifica el campo de consumo de combustible.
     * @param {Vehicle[]} vehicleList
     * @returns fuelEconomyProblem, null si no hay problemas.
     */
    async checkVehiclesFuelEconomy(vehicleList) {
      let fuelEconomyProblem = null;
      let onlyInteger = /^\d+$/;

      vehicleList.forEach((v, index) => {
        if (!onlyInteger.test(v.averageConsumption) && fuelEconomyProblem === null) {
          fuelEconomyProblem = {
            index: index + 1,
            text: `Error en fila ${index + 1}: El consumo promedio debe ser un número entero`,
          };
        }
      });
      return fuelEconomyProblem;
    },
    checkClient() {
      if (this.selectedClient === '' || this.selectedClient === null) {
        this.selectedClient = null;
      }
    },
    hasGrant(client, auth) {
      return canUserAccess(client, auth, this.$store);
    },
    checkVehicle: function (e) {
      console.log(e);
      if (this.selectedAll) {
        this.checkAllVehicle();
      } else {
        this.unCheckAllVehicle();
      }
    },
    checkAllVehicle() {
      this.checkedVehicle = [];
      for (const vehicle of this.vehiclesFilter) {
        this.checkedVehicle.push(vehicle.id);
      }
    },
    unCheckAllVehicle() {
      this.checkedVehicle = [];
    },
    isDate(date) {
      return date instanceof Date;
    },
    async refreshDataClient() {
      await this.getDrivers();
      await this.getDriverVehicle();
      this.getDataBrands();
      this.getDataGroups();
      this.getState();
      this.getFuel();
    },
    async getSelect() {
      await this.getListVehicleTypes();
      this.getListVehicles();
      let dataGroup;
      console.log(this.selectedClient);
      if (this.selectedClient !== null) {
        dataGroup = await this.getGroups();
      }
      this.groups = dataGroup;
      this.populateGroup();
      this.tags = await this.getTags();
      //await this.getDestinations();
      //await this.getSpotType();
      //await this.getCountryList();
    },
    async getTags() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          return response.data.data;
        }
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `getTags fallo ${e.message}`,
        });
        console.log(e);
        return [];
      }
    },
    populateType() {
      this.isLoadingType = true;
      this.optionsType.types = [];
      const typeArray = [];
      for (const type of this.vehicletypes) {
        const option = {
          id: type.id,
          name: type.name,
        };
        if (this.groupClient.indexOf(option.id) !== -1) {
          typeArray.push(option);
        }
      }
      this.optionsType.types = typeArray;
      this.isLoadingType = false;
    },
    async getGroups() {
      this.isLoadingGroup = true;
      const url = `${this.$store.getters.urlAPI}/api/vehicleGroup`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const response = await axios.get(url, config);
      this.isLoadingGroup = false;
      return response.data.data;
    },
    populateGroup() {
      this.optionsGroup = [
        {
          all: 'Todos',
          groups: [],
        },
      ];
      const groupsArray = [];
      for (const group of this.groups) {
        const option = {
          id: group.id,
          name: group.name,
        };
        groupsArray.push(option);
      }
      this.optionsGroup[0].groups = groupsArray;
    },
    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot/simple`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.optionsSpots = response.data.data;
        this.setDestinationsAddressStreet();
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `getDestinations fallo ${e.message}`,
        });
        this.optionsSpots = [];
      }
    },
    async getSpotType() {
      const url = `${this.$store.getters.urlAPI}/api/enum?type=spot_type`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(url, config);
        this.spotTypeList = response.data.data;

        const index = this.spotTypeList.indexOf('Temporal');
        if (index > -1) {
          this.spotTypeList.splice(index, 1);
        }
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `getSpotType fallo ${e.message}`,
        });
        console.log(`${e}, Ha ocurrido un e.`);
      }
    },
    async getCountryList() {
      const url = `${this.$store.getters.urlAPI}/api/country`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const response = await axios.get(url, config);
      response.data.data.forEach((element) => {
        this.countryList.push({
          id: element.id,
          name: element.name,
          iso: element.iso,
        });
      });
      if (this.countryList.length > 0) {
        console.log('Listado de paises listo!');
        this.sortCountryList();
      } else {
        console.log('Listado de paises no listo. No se pueden crear ordenes!');
      }
    },
    sortCountryList() {
      this.countryList.sort(function (a, b) {
        if (a.name > b.name) {
          return 1;
        }
        if (a.name < b.name) {
          return -1;
        }
        // a y b son iguales.
        return 0;
      });
    },
    /**
     * Metodo que obtiene la calle de los destinos.
     */
    setDestinationsAddressStreet() {
      this.optionsSpots.forEach((destination) => {
        destination.addressStreet = destination.address.street;
      });
    },
    async receiveAddressInformation(addressInfo) {
      if (addressInfo.streetName !== '') {
        console.log(addressInfo);
        this.countrySelected = addressInfo.iso.length === 0 ? '' : this.getCountryByIso(addressInfo.iso);
        this.spotForm.address.city = addressInfo.city;
        this.spotForm.address.state = addressInfo.state;
        this.spotForm.address.street =
          addressInfo.number !== undefined ? addressInfo.streetName + ' ' + addressInfo.number : addressInfo.streetName;
        this.spotForm.address.lat = addressInfo.coordinates.lat;
        this.spotForm.address.lon = addressInfo.coordinates.lng;
        this.spotForm.address.country = {
          id: this.countrySelected.id,
        };
        const coordinates = [
          {
            position: {
              lat: this.spotForm.address.lat,
              lng: this.spotForm.address.lon,
            },
          },
        ];
        this.$refs.map.setSpot(coordinates);
        this.$refs.map.createGeoreference(true, 100);
      }
    },
    getCountryByIso(countryIso) {
      let countryMatched = null;
      this.countryList.forEach((element) => {
        if (countryIso === element.iso) {
          countryMatched = element;
        }
      });
      return countryMatched;
    },
    cleanSpotForm() {
      this.spotForm = {
        address: {
          city: null,
          postalCode: null,
          state: null,
          street: '',
          lat: null,
          lon: null,
          country: {
            id: null,
          },
        },
        category: null,
        comments: null,
        contacts: [],
        description: null,
        legalNumber: null,
        legalName: null,
        name: null,
        schedule: [],
        type: 'Temporal',
        zone: [],
      };
    },
    async getListVehicles() {
      this.vehicles = [];
      this.groupClient = [];
      this.isBusy = true;
      const url = `${this.$store.getters.urlAPI}/api/vehicle`;
      if (this.selectedClient === null) {
        this.isBusy = false;
      }
      //FIX-Seguridad: Solo se agrega el token.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      axios
        .get(url, config)
        .then(async (response) => {
          // JSON responses are automatically parsed.
          let dataVehicle = response.data.data;
          if (dataVehicle.length > 0) {
            this.vehicles = dataVehicle;
            this.processListVehicle();
            this.populateType();
          }
          this.isBusy = false;
        })
        .catch((e) => {
          this.logService.sendError({
            component: 'vehicle',
            message: `getListVehicles fallo ${e.message}`,
          });
          console.log(e);
          this.isBusy = false;
        });
    },
    processListVehicle() {
      for (const element of this.vehicles) {
        let lastmileSystem = element.systemsEnabled
          ? element.systemsEnabled.find((system) => system.nemoSystem == 'LML')
          : null;
        element.valueEnable = lastmileSystem && lastmileSystem.enabled === true ? 'Habilitado' : 'Deshabilitado';
        element.fleet = element.vehicleTypeExtra ? element.vehicleTypeExtra.name : '';
        element.groupDesc = element.group ? element.group.name : '';
        if (element.vehicleTypeExtra && this.groupClient.indexOf(element.vehicleTypeExtra.id) === -1) {
          this.groupClient.push(element.vehicleTypeExtra.id);
        }
      }
    },
    processDatesUTC(date) {
      if (date === null) {
        return null;
      }
      try {
        const dateUTC = date.split('-');
        // el -1 es para que marque el mes correcto
        return Date.UTC(parseInt(dateUTC[0]), parseInt(dateUTC[1]) - 1, parseInt(dateUTC[2]), 13, 0, 0);
      } catch (e) {
        console.log(e);
      }
      return null;
      /*const dateUTC = date.split("-");
      // el -1 es para que marque el mes correcto
      return Date.UTC(
        parseInt(dateUTC[0]),
        parseInt(dateUTC[1]) - 1,
        parseInt(dateUTC[2]),
        13,
        0,
        0
      );*/
    },
    addfile(event) {
      this.file = event.target.files[0];
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.file);
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        let data = new Uint8Array(this.arrayBuffer);
        let arr = new Array();
        for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        let bstr = arr.join('');
        let workbook = XLSX.read(bstr, { type: 'binary', cellDates: true });
        let first_sheet_name = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[first_sheet_name];
        this.rowsExcel = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.readFileExcel();
      };
    },
    async readFileExcel() {
      this.rowsExcelTranform = [];
      this.resultValidation = null;
      const listIndexPlate = [];
      const listIndexType = [];
      const listPlateMaxOut = [];
      const listBrandNotExist = [];
      const listEnabledEmpty = [];
      this.prepareFileExcel();
      let idClientTemp = this.$store.getters.clientId;
      let index = 0;
      for (let row of this.rowsExcel) {
        if (row.typeExtra || row.available || row.plate) {
          this.resultValidation = await this.validateDateRequiredExcel(
            row,
            index,
            listIndexPlate,
            listIndexType,
            listPlateMaxOut,
            listBrandNotExist,
            listEnabledEmpty,
          );
          if (this.resultValidation == null) {
            this.missRequiredData = false;
            let vehicleTypeExtra = this.dataVehicleTypeExtra.find((x) => x.name === row.typeExtra);
            let dataGroup = this.dataGroups[0];
            const tagsData = await this.getTagsSelectedExcel(row.tag);

            let depotId = await this.getDepotSelectedExcel(row.depot);

            let brand = null;
            if (row.brand != null) {
              brand = this.dataBrand.find((brand) => row.brand.trim().toLowerCase() === brand.trim().toLowerCase());
              console.log('MArca detectada-', brand, '-marca escrita en excel-', row.brand, '-');
            }
            let vehicle = {
              idClient: idClientTemp,
              name: row.name ? row.name.trim() : '',
              brand: brand != null ? brand : 'Otro',
              vehicleType: {
                id: parseInt(this.$store.getters.idVehicleTypeDefault),
              },
              vehicleTypeExtra: {
                id: vehicleTypeExtra != undefined ? vehicleTypeExtra.id : null,
              },
              group: {
                id: dataGroup != undefined ? dataGroup.id : null,
              },
              plate: row.plate != null ? row.plate.trim() : '',
              tags: tagsData,
              chasis: row.chasis,
              model: row.model != null ? row.model.trim() : '',
              year: null, //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
              color: row.color != null ? row.color.trim() : '',
              observation: row.observation != null ? row.observation.trim() : '',
              status: row.state != null ? row.state.trim() : 'Operativo',
              fuel: row.fuel != null ? row.fuel.trim() : 'diesel', //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
              enabled: true,
              idDepotOrigin: depotId,
              vehicleExtra: {
                id: null,
                fuelEconomy: 0, //Este campo estaba en el excel pero no se estaba capturando ni seteando al json
                tecnicalInspectionDue: row.tecnicalInspectionDue,
                legalPermissionDue: row.dateLegalPermissionDue,
              },
              systemsEnabled: [
                {
                  id: null,
                  idClient: idClientTemp,
                  idSystem: 2,
                  nameSystem: null,
                  nemoSystem: 'LML',
                  enabled: row.available && row.available.toUpperCase() === 'HABILITADO' ? true : false,
                },
              ],
            };
            this.rowsExcelTranform.push(vehicle);
          }
          index += 1;
        }
      }
      if (this.resultValidation != null) {
        this.missRequiredData = true;
        showAlert(this.$t('vehicle.crud.title.massCreate'), this.resultValidation.message, 'error');
        this.closeExcel();
      }
    },
    async validateDateRequiredExcel(
      row,
      index,
      listIndexPlate,
      listIndexType,
      listPlateMaxOut,
      listBrandNotExist,
      listEnabledEmpty,
    ) {
      let vehicleProblem = null;
      if (row.typeExtra == null || row.typeExtra == undefined || row.typeExtra == '') {
        listIndexPlate.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Tipo de vehículo en fila ' + listIndexPlate.toString() + ' es obligatorio',
        };
      }
      if (row.available == null || row.available == undefined || row.available == '') {
        listEnabledEmpty.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'El campo de habilitar/deshabilitar en fila ' + listEnabledEmpty.toString() + ' es obligatorio',
        };
      }
      if (row.plate == null || row.plate == undefined || row.plate == '') {
        listIndexType.push(index + 1);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Patente en fila ' + listIndexType.toString() + ' es obligatorio',
        };
      }
      if (vehicleProblem == null && row.plate.length > 20) {
        listPlateMaxOut.push(row.plate);
        vehicleProblem = {
          status: 'FAIL',
          message: 'Patente: ' + listPlateMaxOut.toString() + ' no puede poseer mas de 20 caracteres',
        };
      }
      if (vehicleProblem == null && row.brand != null && row.brand != undefined) {
        const brand = this.dataBrand.find((brand) => row.brand.trim().toLowerCase() === brand.trim().toLowerCase());
        if (!brand) {
          listBrandNotExist.push(row.brand);
          vehicleProblem = {
            status: 'FAIL',
            message: 'Marca: ' + listBrandNotExist.toString() + ' no corresponde a alguna de las marcas registradas',
          };
        }
      }
      if (vehicleProblem == null && row.tag != null && row.tag != undefined && row.tag != '') {
        const tagsWProblem = await this.validateTags(row.tag);
        if (tagsWProblem != null) {
          const textResult = await this.arrayToText(tagsWProblem);
          vehicleProblem = {
            status: 'FAIL',
            message:
              'Atributos: [' +
              textResult +
              '] en fila ' +
              (index + 2) +
              ' no corresponde a alguna de las marcas registradas',
          };
        }
      }
      return vehicleProblem;
    },
    async arrayToText(array) {
      let text = '';
      for (let tagSplitted of array) {
        text += tagSplitted + ', ';
      }
      return text.length >= 2 ? text.slice(0, -2) : text;
    },
    async validateTags(tags) {
      if (!tags || typeof tags !== 'string') {
        return null; // Maneja casos de entrada no válida
      }

      const tagsSplitted = tags.includes(',') ? tags.split(',') : [tags]; // Normaliza el formato
      const unmatchedTags = [];

      for (let tagSplitted of tagsSplitted) {
        const isMatched = this.tags.some((tagData) => tagData.name === tagSplitted); // Verifica si existe
        if (!isMatched) {
          unmatchedTags.push(tagSplitted);
        }
      }

      return unmatchedTags.length == 0 ? null : unmatchedTags;
    },
    async getTagsSelectedExcel(tagsTemp) {
      if (!tagsTemp) {
        // Maneja null, undefined, y cadenas vacías
        return null;
      }
      const tagsSplitted = tagsTemp.split(',');
      const tagMatched = [];
      for (let tagSplitted of tagsSplitted) {
        for (let tagData of this.tags) {
          if (tagData.name == tagSplitted) {
            tagMatched.push(tagData);
          }
        }
      }
      return tagMatched;
    },
    async getDepotSelectedExcel(depot) {
      for (let depotData of this.optionsSpots) {
        if (depotData.name == depot) {
          return depotData.id;
        }
      }
    },
    async processVehicle() {
      if (!this.isMassiveActive) {
        await this.saveVehicle();
      } else {
        this.confirmUploadExcel();
      }
    },
    async setDriverVehicle(idVehicle, idDriver) {
      let requireChange = true;
      if (idVehicle != null && idDriver != null) {
        this.driverVehicle.forEach((dV) => {
          if (idVehicle === dV.idVehicle[0] && idDriver === dV.idDriver) {
            requireChange = false;
          }
        });
      }
      console.log('idVehicle: ' + idVehicle + ', idDriver: ' + idDriver + ', requireChange: ' + requireChange);

      if (requireChange) {
        //Si recibo el dato nulo, quiero liberar del conductor los vehículos
        let idDriverTemp = null;
        if (idDriver === null) {
          this.driverVehicle.forEach((dV) => {
            if (idVehicle === dV.idVehicle[0]) {
              idDriverTemp = dV.idDriver;
            }
          });
        }
        this.logService.sendInfo({
          component: 'vehicle',
          message: `setDriverVehicle preparando la data idVehicle: ${idVehicle}, idDriver: ${idDriver}, idDriverTemp: ${idDriverTemp}`,
        });
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const url = `${this.$store.getters.urlAPI}/driverVehicle/${idDriver != null ? idDriver : idDriverTemp}/vehicle`;

        this.logService.sendInfo({
          component: 'vehicle',
          message: `setDriverVehicle consultando al servicio ${url}`,
        });
        let idVehicles = idVehicle != null ? [idVehicle] : [];
        if (idDriver === null) {
          idVehicles = [];
        }
        try {
          await axios.put(url, idVehicles, config);
        } catch (e) {
          this.logService.sendError({
            component: 'vehicle',
            message: `setDriverVehicle fallo ${e.message}`,
          });
          console.log(e);
        }
        await this.getDriverVehicle();
      }
    },
    async confirmUploadExcel() {
      if (!this.missRequiredData && this.rowsExcelTranform.length < 1) {
        showAlert('Error', this.$t('vehicle.error.emptyFile'), 'error');
        return;
      }
      showConfirmation(
        this.$t('vehicle.crud.confirm'),
        this.$t('vehicle.crud.bodyConfirm'),
        async () => {
          await this.processExcel();
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    async processExcel() {
      this.isCrudBusy = true;

      let result;
      result = await this.saveMassVehicleRequest();
      if (result.status === 'DONE') {
        showAlert(this.$t('common.modals.exitoTitulo'), this.$t('vehicle.crud.modalSuccessMassive'), 'success');
      } else {
        showAlert(this.$t('vehicle.crud.title.massCreate'), result.message, 'error');
      }
      this.isCrudBusy = false;
      this.closeExcel();
      if (result.status === 'DONE') {
        this.getListVehicles();
      }
    },
    closeExcel() {
      this.$bvModal.hide('save-modal');
    },
    async saveMassVehicleRequest() {
      let response = null;
      let messageResponse = null;
      if (this.resultValidation) {
        return {
          status: 'Fail',
          message: this.$t('vehicle.crud.missingData'),
        };
      }
      try {
        const body = this.rowsExcelTranform;
        this.logService.sendInfo({
          component: 'vehicle',
          message: `saveMassVehicleRequest enviando datos`,
          data: body,
        });
        const ret = await axios.post(`${this.$store.getters.urlAPI}/api/vehicle/request`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            'x-api-key': this.$store.getters.clientApiKey,
          },
        });
        response = ret.data;
        console.log('respuesta del servicio vehículos masivo', response);
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `saveMassVehicleRequest fallo ${e.message}`,
        });
        console.log(e);
      }

      let result = {
        status: null,
        message: null,
      };

      if (response != null) {
        let statusResponse = await this.checkStatus(response.executionId);

        await new Promise((r) => setTimeout(r, 3000));
        let counter = 1;
        let failCounter = 0;
        while (statusResponse === 'notReady' && failCounter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          await new Promise((r) => setTimeout(r, 3000));
          failCounter++;
        }

        if (failCounter === 60) {
          throw new Error('Tiempo de espera excedido');
        }

        while (statusResponse.data.phase !== 'DONE' && statusResponse.data.phase !== 'FAIL' && counter < 60) {
          statusResponse = await this.checkStatus(response.executionId);
          counter++;
          await new Promise((r) => setTimeout(r, 3000));
        }

        if (counter >= 60) {
          result.status = 'FAIL';
          result.message = 'timeout';
          return result;
        }

        if (statusResponse.data.phase === 'DONE') {
          //await this.addVehicleMass(statusResponse.data.vehicleList);
          result.status = 'DONE';
          return result;
        } else {
          messageResponse = statusResponse;
          result.status = 'FAIL';
          result.message =
            messageResponse.data.message != 'Ha ocurrido un error: null'
              ? messageResponse.data.message
              : 'Ha ocurrido un error';
          return result;
        }
      } else {
        result.status = 'FAIL';
        result.message = 'noResponse';
        return result;
      }
    },
    async checkStatus(executionId) {
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        return await axios.get(`${this.$store.getters.urlAPI}/api/vehicle/checkStatus/${executionId}`, config);
      } catch (e) {
        return 'notReady';
      }
    },
    async saveVehicle() {
      console.log('BRAND => ', this.valueBrand);
      console.log('TYPE EXTRA LML=> ', this.valueVehicleTypeExtra);
      console.log('GROUP => ', this.dataGroups[0]);
      console.log('FUEL => ', this.valueFuel);
      console.log('ENABLED => ', this.valueEnable);
      //FIX-Seguridad: Solo se agrega el token.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/vehicle/insert`;
      let paramsForm = {
        name: this.createForm.name ? this.createForm.name.trim() : this.createForm.name,
        plate: this.createForm.plate ? this.createForm.plate.trim() : this.createForm.plate,
        model: this.createForm.model ? this.createForm.model.trim() : this.createForm.model,
        year: this.createForm.year ? parseInt(this.createForm.year.toString().trim()) : this.createForm.year,
        chasis: this.createForm.chasis ? this.createForm.chasis.trim() : this.createForm.chasis,
        color: this.createForm.color ? this.createForm.color.trim() : this.createForm.color,
        observation: this.createForm.observation ? this.createForm.observation.trim() : this.createForm.observation,
        brand: this.valueBrand,
        fuel: this.valueFuel,
        status: 'Operativo',
        systemsEnabled: [
          {
            idSystem: 2,
            nemoSystem: 'LML',
            enabled: this.valueEnable.bool,
          },
        ],
        enabled: true,
        vehicleType: {
          id: parseInt(this.$store.getters.idVehicleTypeDefault),
        },
        vehicleTypeExtra: {
          id: this.valueVehicleTypeExtra !== null ? this.valueVehicleTypeExtra.id : undefined,
        },
        group: {
          id: this.dataGroups[0] ? (!isNaN(this.dataGroups[0]) ? this.dataGroups[0] : this.dataGroups[0].id) : null,
        },
        vehicleExtra: {
          fuelEconomy: this.createForm.vehicleExtra.fuelEconomy,
          tecnicalInspectionDue: this.processDatesUTC(this.dateTecnicalInspectionDue),
          legalPermissionDue: this.processDatesUTC(this.dateLegalPermissionDue),
        },
        idDepotOrigin: this.selectedDepot ? this.selectedDepot.id : null,
      };
      let formInput = {
        name: paramsForm.name,
        brand: paramsForm.brand,
        vehicleType: paramsForm.vehicleType,
        vehicleTypeExtra: paramsForm.vehicleTypeExtra.id,
        group: paramsForm.group.id,
        plate: paramsForm.plate,
        model: paramsForm.model,
        year: paramsForm.year,
        chasis: paramsForm.chasis,
        color: paramsForm.color,
        observation: paramsForm.observation,
        status: paramsForm.status,
        fuel: paramsForm.fuel,
        fuelEconomy: paramsForm.vehicleExtra.fuelEconomy,
        enabled: this.valueEnable.name,
      };

      //Validación en caso de nulo.
      if (paramsForm.brand.length == 0) {
        paramsForm.brand = 'Otro';
      }
      if (paramsForm.chasis.length == 0) {
        paramsForm.chasis = null;
      }
      if (paramsForm.vehicleExtra.fuelEconomy.length == 0) {
        paramsForm.vehicleExtra.fuelEconomy = 10;
      }
      if (paramsForm.fuel.length == 0) {
        paramsForm.fuel = 'diesel';
      }
      if (this.selectedTags && !Array.isArray(this.selectedTags)) {
        this.selectedTags = [this.selectedTags];
        paramsForm.tags = this.selectedTags && this.selectedTags.length > 0 ? this.selectedTags : [];
      } else {
        paramsForm.tags = this.selectedTags.length > 0 ? this.selectedTags : [];
      }

      let result = await this.validateForm(formInput);
      if (result) {
        await this.validateSelectedDriverForNewVehicle(result, url, paramsForm, config);
      }
    },
    newSpotActivated(spot, path) {
      if (spot !== null && spot.id === -1) {
        this.temporalSpotPath = path;
        this.temporalSpotRequired = true;
      } else if (spot !== null) {
        if (path === 'origin') {
          this.originAddressStreet = spot.addressStreet;
        }
      } else if (spot === null) {
        if (path === 'origin') {
          this.originAddressStreet = null;
        }
      }
    },
    deleteProperties() {
      delete this.updateForm.fleet;
      delete this.updateForm.groupDesc;
    },
    async updateVehicle() {
      //FIX-Seguridad: Solo se agrega el token.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const sendId = this.detail.id;
      const url = `${this.$store.getters.urlAPI}/api/vehicle/${sendId}`;
      this.updateForm = this.detail;
      this.deleteProperties();
      this.valueLegalPermissionDue = this.isDate(this.valueLegalPermissionDue)
        ? this.valueLegalPermissionDue
        : this.processDatesUTC(this.valueLegalPermissionDue);
      this.valueTecnicalInspectionDue = this.isDate(this.valueTecnicalInspectionDue)
        ? this.valueTecnicalInspectionDue
        : this.processDatesUTC(this.valueTecnicalInspectionDue);
      const paramsForm = {
        name: this.updateForm.name ? this.updateForm.name.trim() : this.updateForm.name,
        plate: this.updateForm.plate ? this.updateForm.plate.trim() : this.updateForm.plate,
        model: this.updateForm.model ? this.updateForm.model.trim() : this.updateForm.model,
        year: this.updateForm.year ? parseInt(this.updateForm.year.toString().trim()) : this.updateForm.year,
        chasis: this.updateForm.chasis ? this.updateForm.chasis.trim() : this.updateForm.chasis,
        color: this.updateForm.color ? this.updateForm.color.trim() : this.updateForm.color,
        observation: this.updateForm.observation ? this.updateForm.observation.trim() : this.updateForm.observation,
        brand: this.valueBrand,
        fuel: this.valueFuel,
        status: 'Operativo',
        systemsEnabled: [
          {
            idSystem: 2,
            nemoSystem: 'LML',
            enabled: this.valueEnable.bool,
          },
        ],
        enabled: true,
        vehicleType: {
          id:
            this.updateForm && this.updateForm.vehicleType
              ? this.updateForm.vehicleType.id
              : parseInt(this.$store.getters.idVehicleTypeDefault),
        },
        vehicleTypeExtra: {
          id: this.valueVehicleTypeExtra !== null ? this.valueVehicleTypeExtra.id : undefined,
        },
        group: {
          id: this.dataGroups[0] ? (!isNaN(this.dataGroups[0]) ? this.dataGroups[0] : this.dataGroups[0].id) : null,
        },
        vehicleExtra: {
          id: sendId,
          fuelEconomy: this.valueFuelEconomy,
          tecnicalInspectionDue: this.valueTecnicalInspectionDue,
          legalPermissionDue: this.valueLegalPermissionDue,
        },
        idDepotOrigin: this.selectedDepot ? this.selectedDepot.id : null,
      };
      let formInput = {
        name: paramsForm.name,
        brand: paramsForm.brand,
        vehicleType: paramsForm.vehicleType.id,
        vehicleTypeExtra: paramsForm.vehicleTypeExtra.id,
        group: paramsForm.group.id,
        plate: paramsForm.plate,
        model: paramsForm.model,
        year: paramsForm.year,
        color: paramsForm.color,
        observation: paramsForm.observation,
        status: paramsForm.status,
        fuel: paramsForm.fuel,
        fuelEconomy: paramsForm.vehicleExtra.fuelEconomy,
        enabled: this.valueEnable.name,
      };

      //Validación en caso de nulo.
      if (paramsForm.brand.length == 0) {
        paramsForm.brand = 'Otro';
      }
      if (paramsForm.year.length == 0) {
        paramsForm.year = 2000;
      }
      if (paramsForm.vehicleExtra.fuelEconomy.length == 0) {
        paramsForm.vehicleExtra.fuelEconomy = 10;
      }
      if (paramsForm.fuel.length == 0) {
        paramsForm.fuel = 'diesel';
      }

      if (this.selectedTags && !Array.isArray(this.selectedTags)) {
        this.selectedTags = [this.selectedTags];
        paramsForm.tags = this.selectedTags && this.selectedTags.length > 0 ? this.selectedTags : [];
      } else {
        paramsForm.tags = this.selectedTags.length > 0 ? this.selectedTags : [];
      }

      let result = await this.validateForm(formInput);
      console.log(result);
      if (result) {
        await this.validateSelectedDriverForEditVehicle(result, url, paramsForm, config);
      }
    },
    async validateSelectedDriverForEditVehicle(result, url, paramsForm, config) {
      try {
        this.createPreassignationOnConflict = true;
        let preAssignmentFinded = false;
        if (this.selectedDriver) {
          this.driverVehicle.forEach((e) => {
            if (this.selectedDriver.id === e.idDriver && this.detail.id !== e.idVehicle[0]) {
              this.showToast(e, result, url, paramsForm, config, 'edit');
              preAssignmentFinded = true;
            }
          });
        }

        if (preAssignmentFinded === false) {
          await this.editVehicle(result, url, paramsForm, config);
        }
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `validateSelectedDriverForEditVehicle fallo ${e.message}`,
        });
        this.isCrudBusy = false;
        responseCodeManager(e);
      }
    },
    async editVehicle(result, url, paramsForm, config) {
      if (result) {
        this.isCrudBusy = true;
        const response = await axios.patch(url, paramsForm, config);
        if (response.data.data != null && this.createPreassignationOnConflict) {
          await this.getListVehicles();

          //Busco al viejo conductor del vehículo editado y lo desvinculo
          const driverTemp = this.driverVehicle.find((e) => response.data.data.id === e.idVehicle[0]);
          if (driverTemp !== undefined) {
            this.logService.sendInfo({
              component: 'vehicle',
              message: `editVehicle se desvinculara el siguiente conductor`,
              data: driverTemp,
            });
            await this.setDriverVehicle(null, driverTemp.idDriver);
          }
          this.logService.sendInfo({
            component: 'vehicle',
            message: `editVehicle se vinculara el nuevo conductor`,
            data: this.selectedDriver,
          });
          //Vinculo al nuevo conductor
          await this.setDriverVehicle(
            response.data.data.id,
            this.selectedDriver != null ? this.selectedDriver.id : null,
          );
        }
        if (response.status === 200) {
          this.getListVehicles();
          this.closeModal('update-modal');
          this.selectedTags = [];
          this.selectedDepot = null;
          this.selectedDriver = null;
          showAlert(this.$t('vehicle.modals.title.update'), this.$t('vehicle.modals.body.update'), 'exito');
        } else {
          this.closeModal('update-modal');
          this.selectedTags = [];
          this.selectedDepot = null;
          this.selectedDriver = null;
          showAlert(this.$t('vehicle.modals.title.update'), this.$t('vehicle.modals.error.update'), 'error');
        }
        this.isCrudBusy = false;
      }
    },
    async detailVehicle(vehicle) {
      const driverMap = new Map(this.drivers.map((d) => [d.id, d]));
      // Buscar el driver correspondiente
      const match = this.driverVehicle.find((dV) => vehicle.id === dV.idVehicle[0]);

      if (match) {
        const driver = driverMap.get(match.idDriver);
        if (driver) {
          vehicle.driver = driver;
        }
      }
      this.$store.commit('setVehicles', this.vehicles);
      vehicleCrudModal(
        true,
        false,
        vehicle,
        {
          drivers: this.drivers,
          driverVehicle: this.driverVehicle,
        },
        this.dataVehicleTypeExtra,
        this.tags,
        this.dataGroups,
        async (vehicle, idDriver, updateListVeh) => {
          //Unicamente si vienen ambos id procedo a actualizar la preasignación
          if (idDriver) {
            await this.setDriverVehicle(vehicle && vehicle.id ? vehicle.id : null, idDriver);
          }
          if (updateListVeh) {
            this.isBusy = true;
            await this.getListVehicles();
            this.isBusy = false;
          }
        },
      );
    },
    async getTagIdVehicle(id) {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag/vehicle/${id}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          return response.data.data;
        }
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    sendInfoVehicle(vehicle) {
      this.selectedVehicle = vehicle;
    },
    openMassDeleteModal() {
      this.showModal('confirm-mass-delete');
    },
    async massiveDelete() {
      try {
        this.closeModal('confirm-mass-delete');
        this.isBusy = true;
        const response = await axios.post(`${this.$store.getters.urlAPI}/api/vehicle/massDelete`, this.checkedVehicle, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(
            this.$t('common.modals.exitoTitulo'),
            this.$t('vehicle.massModal.successful.massDelete'),
            'success',
          );
          await this.getListVehicles();
          this.isBusy = false;
        }
      } catch (e) {
        this.logService.sendError({
          component: 'vehicle',
          message: `massiveDelete fallo ${e.message}`,
        });
        this.isBusy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('vehicle.massModal.error.massDelete'), 'error');
      }
    },
    deleteVehicle() {
      //FIX-Seguridad: Solo se agrega el token.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      this.isBusy = true;
      this.responseSave = this.selectedVehicle.name;
      let urlDelete = `${this.$store.getters.urlAPI}/api/vehicle/${this.selectedVehicle.id}`;
      axios
        .delete(urlDelete, config)
        .then((response) => {
          console.log(response);
          this.isBusy = false;
          this.getListVehicles();
          this.closeModal('modalDeleteVehicleConfirm');
          showAlert(this.$t('vehicle.modals.title.delete'), this.$t('vehicle.modals.body.delete'), 'exito');
        })
        .catch((e) => {
          showAlert(this.$t('vehicle.modals.title.delete'), this.$t('vehicle.modals.error.delete'), 'error');
          console.log('error' + e);
        });
    },
    async getDriverVehicle() {
      this.driverVehicle = [];
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const url = `${this.$store.getters.urlAPI}/driverVehicle`;
      try {
        const response = await axios.get(url, config);
        this.driverVehicle = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDrivers() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/driver?provider=true`;
      try {
        const response = await axios.get(url, config);
        this.drivers = response.data.data;
        this.drivers.forEach((driver) => {
          driver.identifier = driver.username + ' | ' + driver.firstName + ' ' + driver.lastName;
        });
      } catch (error) {
        console.log(error);
      }
    },
    async getDataBrands() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/enum?type=vehicle_brand`;
      try {
        const { data } = await axios.get(url, config);
        const { data: brands } = data;
        this.dataBrand = brands;
      } catch (error) {
        console.log(error);
      }
    },
    async getDataGroups() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/vehicleGroup`;
      try {
        let { data } = await axios.get(url, config);
        let { data: groups } = data;
        this.dataGroups = groups.reverse();
        this.dataMassiveAux = this.dataGroups;
        this.dataGroupExcel = await this.prepareGroups();
        this.groupCellWidth = this.calculateDropdownCellWitch(this.dataGroups);
      } catch (error) {
        console.log(error);
      }
    },
    prepareDataGroupName() {
      for (let index in this.dataMassiveAux) {
        if (this.dataMassiveAux[index].idParent > 0) {
          console.log(index);
          this.dataMassiveAux[index].pathName = this.checkChild(this.dataMassiveAux[index], '');
        }
      }
    },
    checkChild(currentGroup, text) {
      if (currentGroup.idParent !== 0) {
        text = text + currentGroup.name;
      }
      for (let i in this.dataMassiveAux) {
        if (this.dataMassiveAux[i].id === currentGroup.idParent) {
          text = this.dataMassiveAux[i].name + ' / ' + text;
          return this.checkChild(this.dataMassiveAux[i], text);
        }
      }
      return text;
    },
    async getState() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/enum?type=vehicle_status`;
      try {
        const { data } = await axios.get(url, config);
        const { data: status } = data;
        this.dataStatus = status;
        return status;
      } catch (error) {
        console.log(error);
      }
    },
    async depotToUse(newDepot) {
      this.isCrudBusy = true;
      this.selectedDepot = newDepot;
      await this.getDestinations();
      this.isCrudBusy = false;
    },
    closeSpotForm() {
      this.selectedDepot = null;
      this.closeModal('create-temporal-spot-modal');
    },
    async getFuel() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/enum?type=vehicle_fuel`;
      try {
        if (this.dataFuel != null && this.dataFuel.length > 0) return this.dataFuel;
        const { data } = await axios.get(url, config);
        const { data: fuel } = data;
        this.dataFuel = fuel.reverse();
        return this.dataFuel;
      } catch (error) {
        console.log(error);
      }
    },
    openCreate() {
      this.$store.commit('setVehicles', this.vehicles);
      vehicleCrudModal(
        false,
        true,
        null,
        {
          drivers: this.drivers,
          driverVehicle: this.driverVehicle,
        },
        this.dataVehicleTypeExtra,
        this.tags,
        this.dataGroups,
        async (vehicle, idDriver, updateListVeh) => {
          //Unicamente si vienen ambos id procedo a actualizar la preasignación
          if (idDriver) {
            await this.setDriverVehicle(vehicle && vehicle.id ? vehicle.id : null, idDriver);
          }
          if (updateListVeh) {
            this.isBusy = true;
            await this.getListVehicles();
            this.isBusy = false;
          }
        },
      );
    },
    resetForm() {
      this.createForm = {
        name: '',
        brand: '',
        vehicleType: {
          id: 1,
        },
        group: {
          id: 1998,
        },
        plate: '',
        chasis: '',
        model: '',
        year: '',
        color: '',
        observation: '',
        status: '',
        fuel: '',
        enabled: true,
        vehicleExtra: {
          id: '',
          fuelEconomy: '',
          tecnicalInspectionDue: '',
          legalPermissionDue: '',
        },
      };
    },
    acceptUpdate() {
      this.$refs[this.modalSave].hide();
    },
    closeModal(modal) {
      this.$refs[modal].hide();
    },
    clearSpotDataDetail() {
      this.spotForm.name = null;
      this.spotForm.legalName = null;
      this.spotForm.legalNumber = null;
      this.spotForm.type = null;
    },

    /**
     * Funciones para desactivar el filtro clickeando fuera de la pantalla
     */
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    async validateForm(formInput) {
      //Inicio de chequeo del form.
      return this.checkForm(this.$root, this.parameterFields, formInput);
    },
    async validateFormTypes(formInput) {
      //Inicio de chequeo del form.
      return this.checkForm(this.$root, this.parameterFieldsType, formInput);
    },
    async validateSelectedDriverForNewVehicle(result, url, paramsForm, config) {
      this.createPreassignationOnConflict = true;
      let preAssignmentFinded = false;
      if (this.selectedDriver) {
        this.driverVehicle.forEach((e) => {
          if (this.selectedDriver.id === e.idDriver) {
            this.showToast(e, result, url, paramsForm, config, 'create');
            preAssignmentFinded = true;
          }
        });
      }
      if (preAssignmentFinded === false) {
        await this.postVehicle(result, url, paramsForm, config);
      }
    },
    async showToast(vehicleBussy, result, url, paramsForm, config, crud) {
      const h = this.$createElement;
      const id = `my-toast-driver-busy-warning`;

      const $closeButton = h(
        'b-button',
        {
          on: {
            click: async () => {
              await this.$bvToast.hide(id);
              this.createPreassignationOnConflict = false;
              return null;
            },
          },
        },
        this.$t('vehicle.crud.buttons.cancel'),
      );
      const $acceptButton = h(
        'b-button',
        {
          class: ['float-right'],
          props: { variant: 'success' },
          on: {
            click: async () => {
              await this.$bvToast.hide(id);
              this.createPreassignationOnConflict = true;
              if (crud === 'create') {
                return await this.postVehicle(result, url, paramsForm, config);
              } else {
                return await this.editVehicle(result, url, paramsForm, config);
              }
            },
          },
        },
        this.$t('vehicle.crud.buttons.confirm'),
      );
      const vehicleTemp = this.vehicles.find((element) => element.id == vehicleBussy.idVehicle);
      let $vNodesMsg = h('p', { class: ['text-left', 'y-16'] }, [
        this.$t('vehicle.crud.assignBusy', { plate: vehicleTemp.plate }),
      ]);

      const $vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] }, [
        h('strong', { class: 'mr-2-xl' }, 'Confirmación'),
      ]);

      this.$bvToast.toast([$vNodesMsg, $closeButton, $acceptButton], {
        id: id,
        title: [$vNodesTitle],
        variant: 'alert',
        toaster: 'b-toaster-top-center',
        noCloseButton: true,
        static: true,
        noAutoHide: true,
        solid: true,
      });
    },
    async postVehicle(result, url, paramsForm, config) {
      if (result) {
        try {
          this.isCrudBusy = true;
          const response = await axios.post(url, paramsForm, config);
          if (response.data.data != null && this.createPreassignationOnConflict) {
            await this.getListVehicles();

            if (this.selectedDriver != null) {
              this.logService.sendInfo({
                component: 'vehicle',
                message: `postVehicle se selecciono un conductor `,
                data: this.selectedDriver,
              });
              await this.setDriverVehicle(response.data.data.id, this.selectedDriver.id);
            }
          }
          if (response.status === 201) {
            this.getListVehicles();
            this.selectedTags = [];
            this.selectedDepot = null;
            this.selectedDriver = null;
            showAlert(this.$t('vehicle.modals.title.create'), this.$t('vehicle.modals.body.create'), 'exito');
            this.$refs[this.modalSave].hide();
          } else if (response.status === 400) {
            console.log('Hay uno o más campos mal ingresados.');
          } else {
            this.selectedTags = [];
            this.selectedDepot = null;
            this.selectedDriver = null;
            this.$refs[this.modalSave].hide();
            showAlert(this.$t('vehicle.modals.title.create'), this.$t('vehicle.modals.error.create'), 'error');
          }
          this.isCrudBusy = false;
          return response.data.data;
        } catch (e) {
          this.isCrudBusy = false;
          let messageSplitted = e.response.data.split(',');
          let messageResult = '';
          this.logService.sendError({
            component: 'vehicle',
            message: `postVehicle fallo en su creación ${e.message}`,
            data: paramsForm,
          });
          messageSplitted.forEach((text) => {
            if (text.search('message') != -1) {
              messageResult = text.split('=')[1];
            }
          });
          showAlert('¡Lo sentimos! ', messageResult);
          return null;
        }
      }
    },
    async massCreation() {
      return null;
    },
    clearType() {
      this.selectedType = [];
      this.optionsType.types = [];
    },
    firstPage() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      }
    },
    getChilds(group, rawData) {
      let groups = [];
      const id = group ? group.id : null;
      if (id) {
        groups = rawData
          .filter((grupo) => grupo.idParent === id)
          .map((grupo) => {
            return {
              ...grupo,
              parentName: group.name,
            };
          });
      } else {
        groups = rawData
          .filter((grupo) => !grupo.idParent)
          .map((grupo) => {
            return {
              ...grupo,
              parentName: 'Raiz',
            };
          });
      }
      return groups.map((grupo) => {
        let children = this.getChilds(grupo, rawData);
        return {
          ...grupo,
          childs: children,
        };
      });
    },
    prepareGroups() {
      this.hierarchyGroups = this.getChilds(null, this.dataGroups);
      this.hierarchyGroups.sort(function (a, b) {
        let textA = a.name.toUpperCase();
        let textB = b.name.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

      this.hierarchyGroups.forEach((element) => {
        element.routeName = element.name;
        for (let index in this.dataGroups) {
          if (element.id == this.dataGroups[index].id) {
            this.dataGroups[index].routeName = element.routeName;
          }
        }
        this.checkGroup(element);
      });

      let tempGroup = [];
      this.dataGroups.forEach((element) => {
        if (element.routeName !== undefined) {
          tempGroup.push(element.routeName);
        }
      });
      tempGroup.sort(function (a, b) {
        const firstWordsA = a.split('/')[0];
        const firstWordsB = b.split('/')[0];
        if (firstWordsA > firstWordsB) {
          return 1;
        }
        if (firstWordsA < firstWordsB) {
          return -1;
        }
        return 0;
      });
      return tempGroup;
    },
    showPopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::show::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'wrong-input';
      this.$root.$emit('bv::hide::popover', id);
      const multiselect = document.querySelector(`#${id} .multiselect`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
    hideError(originalReference) {
      if (originalReference === this.errorReference) {
        this.errorReference = null;
      }
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    checkGroup(group) {
      group.childs.forEach((element) => {
        element.routeName = group.routeName + '/' + element.name;
        for (let index in this.dataGroups) {
          if (element.id == this.dataGroups[index].id) {
            this.dataGroups[index].routeName = element.routeName;
          }
        }
        this.checkGroup(element);
      });
    },
    calculateDropdownCellWitch(dataArray) {
      let maxWidth = 0;
      dataArray.forEach((element) => {
        if (element.routeName !== undefined && element.routeName.length > maxWidth) {
          maxWidth = element.routeName.length;
        }
      });
      maxWidth = maxWidth * 5.8;
      if (maxWidth > 950) {
        maxWidth = 950;
      }
      return maxWidth > 200 ? maxWidth : 200;
    },

    checkVehicleType: function (e) {
      console.log(e);
      if (this.selectedAllVehicleTypes) {
        this.checkAllVehicleType();
      } else {
        this.unCheckAllVehicleType();
      }
    },
    checkAllVehicleType() {
      this.vehicleTypesSelected = [];
      for (const vehicleType of this.filtered) {
        this.vehicleTypesSelected.push(vehicleType.id);
      }
    },
    unCheckAllVehicleType() {
      this.vehicleTypesSelected = [];
    },
    dateTable(d) {
      const result = new Date(d);
      return this.formatDate(result);
    },
    formatDate(d) {
      let month = `${d.getMonth() + 1}`;
      let day = `${d.getDate()}`;
      const year = `${d.getFullYear()}`;

      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [day, month, year].join('-');
    },
    async getListVehicleTypes() {
      this.isBusy = true;
      this.vehicletypes = [];
      this.dataVehicleTypeExtra = [];
      try {
        const url = `${this.$store.getters.urlAPI}/api/vehicleTypeExtra`;
        //FIX-Seguridad: Se agrega configuracion.
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        // JSON responses are automatically parsed.
        let dataVehicletype = response.data.data;
        if (dataVehicletype.length > 0) {
          dataVehicletype.forEach((type) => {
            const body = {
              id: type.id,
              icon: type.icon,
              name: type.name,
              category: type.category ? type.category : null,
              maxWeigth: type.maxWeigth,
              maxMoney: type.maxMoney,
              maxVolume: type.maxVolume,
              maxKms: type.maxKms,
              maxVisits: type.maxVisits,
              maxTime: type.maxTime,
              maxTimeDriving: type.maxTimeDriving,
              maxContinuousTimeDriving: type.maxContinuousTimeDriving,
              createdAtFormat: this.dateTable(type.createdAt),
              modifiedAtFormat: this.dateTable(type.modifiedAt),
            };
            this.vehicletypes.push(body);
            this.dataVehicleTypeExtra.push(body);
          });
        }
        this.vehicletypes.sort(function (a, b) {
          let textA = a.name.toUpperCase();
          let textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        this.dataVehicleTypeExtra = this.dataVehicleTypeExtra.reverse();
        this.update++;
        this.isBusy = false;
      } catch (e) {
        alert(e);
      }
    },
    async saveVehicleType() {
      const url = `${this.$store.getters.urlAPI}/api/vehicleTypeExtra`;
      const formCreated = { ...this.createForm };
      const formInput = {
        name: this.createForm.name,
        maxVolume: this.createForm.maxVolume ? this.createForm.maxVolume : 0,
        maxWeigth: this.createForm.maxWeigth ? this.createForm.maxWeigth : 0,
        maxMoney: this.createForm.maxMoney ? this.createForm.maxMoney : 0,
        maxKms: this.createForm.maxKms ? this.createForm.maxKms : 0,
        maxVisits: this.createForm.maxVisits ? this.createForm.maxVisits : 0,
        maxTime: this.createForm.maxTime ? this.createForm.maxTime : 0,
        maxTimeDriving: this.createForm.maxTimeDriving ? this.createForm.maxTimeDriving : 0,
        maxContinuousTimeDriving: this.createForm.maxContinuousTimeDriving
          ? this.createForm.maxContinuousTimeDriving
          : 0,
      };
      //FIX-Seguridad: Se agrega configuracion.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      let result = await this.validateFormTypes(formInput);
      if (result) {
        try {
          const response = await axios.post(url, formCreated, config);
          if (response.status === 201) {
            this.$refs['save-modal-type'].hide();
            showAlert(this.$t('vehicleType.modals.title.create'), this.$t('vehicleType.modals.body.create'), 'exito');
            this.getListVehicleTypes();
            this.createForm.name = '';
            this.createForm.icon = '';
            this.createForm.maxVolume = null;
            this.createForm.maxWeigth = null;
            this.createForm.maxMoney = null;
            this.createForm.maxKms = null;
            this.createForm.maxVisits = null;
            this.createForm.maxTime = null;
            this.createForm.maxTimeDriving = null;
            this.createForm.maxContinuousTimeDriving = null;
          } else if (response.status === 400) {
            console.log('Hay uno o más campos mal ingresados.');
          } else {
            this.$refs['save-modal-type'].hide();
            showAlert(this.$t('vehicleType.modals.title.create'), this.$t('vehicleType.modals.error.create'), 'error');
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    async updateVehicleType() {
      const sendId = this.detail.id;
      const url = `${this.$store.getters.urlAPI}/api/vehicleTypeExtra/${sendId}`;
      const formModified = {
        ...this.updateForm,
        maxWeigth: this.updateForm.maxWeigth ? this.updateForm.maxWeigth : 0,
        maxMoney: this.updateForm.maxMoney ? this.updateForm.maxMoney : 0,
        maxVolume: this.updateForm.maxVolume ? this.updateForm.maxVolume : 0,
        maxKms: this.updateForm.maxKms ? this.updateForm.maxKms : 0,
        maxVisits: this.updateForm.maxVisits ? this.updateForm.maxVisits : 0,
        maxTime: this.updateForm.maxTime ? this.updateForm.maxTime : 0,
        maxTimeDriving: this.updateForm.maxTimeDriving ? this.updateForm.maxTimeDriving : 0,
        maxContinuousTimeDriving: this.updateForm.maxContinuousTimeDriving
          ? this.updateForm.maxContinuousTimeDriving
          : 0,
      };
      const formInput = {
        name: this.updateForm.name,
        maxWeigth: this.updateForm.maxWeigth ? this.updateForm.maxWeigth : 0,
        maxMoney: this.updateForm.maxMoney ? this.updateForm.maxMoney : 0,
        maxVolume: this.updateForm.maxVolume ? this.updateForm.maxVolume : 0,
        maxKms: this.updateForm.maxKms ? this.updateForm.maxKms : 0,
        maxVisits: this.updateForm.maxVisits ? this.updateForm.maxVisits : 0,
        maxTime: this.updateForm.maxTime ? this.updateForm.maxTime : 0,
        maxTimeDriving: this.updateForm.maxTimeDriving ? this.updateForm.maxTimeDriving : 0,
        maxContinuousTimeDriving: this.updateForm.maxContinuousTimeDriving
          ? this.updateForm.maxContinuousTimeDriving
          : 0,
      };
      //FIX-Seguridad: Se agrega configuracion.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      let result = await this.validateFormTypes(formInput);
      if (result) {
        try {
          const response = await axios.patch(url, formModified, config);
          if (response.status === 200) {
            this.closeModal('update-modal-type');
            showAlert(this.$t('vehicleType.modals.title.update'), this.$t('vehicleType.modals.body.update'), 'exito');
            //await this.cleanCache();
            this.getListVehicleTypes();
          } else {
            this.closeModal('update-modal-type');
            showAlert(this.$t('vehicleType.modals.title.update'), this.$t('vehicleType.modals.error.update'), 'error');
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    detailVehicletype(vehicletype) {
      this.detail = vehicletype;
      this.detail.maxWeigth = vehicletype.maxWeigth != 0 ? vehicletype.maxWeigth : null;
      this.detail.maxMoney = vehicletype.maxMoney != 0 ? vehicletype.maxMoney : null;
      this.detail.maxVolume = vehicletype.maxVolume != 0 ? vehicletype.maxVolume : null;
      this.detail.maxKms = vehicletype.maxKms != 0 ? vehicletype.maxKms : null;
      this.detail.maxVisits = vehicletype.maxVisits != 0 ? vehicletype.maxVisits : null;
      this.detail.maxTime = vehicletype.maxTime != 0 ? vehicletype.maxTime : null;
      this.detail.maxTimeDriving = vehicletype.maxTimeDriving != 0 ? vehicletype.maxTimeDriving : null;
      this.detail.maxContinuousTimeDriving =
        vehicletype.maxContinuousTimeDriving != 0 ? vehicletype.maxContinuousTimeDriving : null;
      this.updateForm.id = vehicletype.id;
      this.updateForm.name = vehicletype.name;
      this.updateForm.icon = vehicletype.icon;
      this.updateForm.maxWeigth = vehicletype.maxWeigth != 0 ? vehicletype.maxWeigth : null;
      this.updateForm.maxMoney = vehicletype.maxMoney != 0 ? vehicletype.maxMoney : null;
      this.updateForm.maxVolume = vehicletype.maxVolume != 0 ? vehicletype.maxVolume : null;
      this.updateForm.maxKms = vehicletype.maxKms != 0 ? vehicletype.maxKms : null;
      this.updateForm.maxVisits = vehicletype.maxVisits != 0 ? vehicletype.maxVisits : null;
      this.updateForm.maxTime = vehicletype.maxTime != 0 ? vehicletype.maxTime : null;
      this.updateForm.maxTimeDriving = vehicletype.maxTimeDriving != 0 ? vehicletype.maxTimeDriving : null;
      this.updateForm.maxContinuousTimeDriving =
        vehicletype.maxContinuousTimeDriving != 0 ? vehicletype.maxContinuousTimeDriving : null;
    },
    sendInfoVehicletype(vehicletype) {
      this.selectedVehicletype = vehicletype;
    },
    async massiveDeleteType() {
      try {
        this.closeModal('confirm-mass-delete');
        this.isBusy = true;
        const response = await axios.post(
          `${this.$store.getters.urlAPI}/api/vehicleTypeExtra/massDelete`,
          this.vehicleTypesSelected,
          {
            headers: {
              'id-client': this.$store.getters.clientId,
              Authorization: `Bearer ${this.$store.getters.accessToken}`,
            },
          },
        );
        if (response.data.status) {
          showAlert(
            this.$t('common.modals.exitoTitulo'),
            this.$t('vehicleType.massModal.successful.massDelete'),
            'success',
          );
          await this.getListVehicleTypes();
          this.isBusy = false;
        }
      } catch (e) {
        this.isBusy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('vehicleType.massModal.error.massDelete'), 'error');
      }
    },
    deleteVehicletype() {
      this.isBusy = true;
      this.responseSave = this.selectedVehicletype.name;
      let urlDelete = `${this.$store.getters.urlAPI}/api/vehicleTypeExtra/${this.selectedVehicletype.id}`;
      //FIX-Seguridad: Se agrega configuracion.
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      axios
        .delete(urlDelete, config)
        .then(async (response) => {
          // JSON responses are automatically parsed.
          console.log(response);
          if (response.data.status) {
            this.isBusy = false;
            this.vehicletypes = [];
            //await this.cleanCache();
            this.getListVehicleTypes();
            this.closeModal('modalDeleteVehicletypeConfirm');
            showAlert(this.$t('vehicleType.modals.title.delete'), this.$t('vehicleType.modals.body.delete'), 'exito');
          } else {
            this.isBusy = false;
            this.closeModal('modalDeleteVehicletypeConfirm');
            showAlert(this.$t('vehicleType.modals.title.delete'), this.$t('vehicleType.modals.error.bussy'), 'error');
          }
        })
        .catch((e) => {
          this.closeModal('modalDeleteVehicletypeConfirm');
          showAlert(this.$t('vehicleType.modals.title.delete'), this.$t('vehicleType.modals.error.delete'), 'error');
          console.log('error' + e);
        });
    },
    deleteVehicleType(vehicletype) {
      this.selectedVehicletype = vehicletype;
    },
    isVehicleComplete(vehicle) {
      const vehicleTypeExtra = vehicle.vehicleTypeExtra ? true : false;
      const group = vehicle.group ? true : false;
      const vehicleType = vehicle.vehicleType ? true : false;
      return vehicleTypeExtra && group && vehicleType;
    },
    buildPlaceholder(text) {
      return `${text} ${this.$t('vehicleType.placeholders.max')}`;
    },
  },
  computed: {
    renderedOrigins() {
      return [
        {
          id: -1,
          name: this.$t('vehicle.modals.otros.crearNuevoOrigen'),
          addressStreet: null,
        },
        ...this.optionsSpots,
      ];
    },
    vehicleTypeFields() {
      const common = {
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          class: 'text-center',
          label: '',
          ...common,
        },
        {
          key: 'name',
          class: 'text-center',
          label: this.$t('vehicleType.table.name'),
          ...common,
        },
        {
          key: 'maxVolume',
          class: 'text-center',
          label: this.$t('vehicleType.table.maxVolume') + ' (m3)',
          ...common,
        },
        {
          key: 'maxWeigth',
          class: 'text-center',
          label: this.$t('vehicleType.table.maxWeigth') + ' (kg)',
          ...common,
        },
        {
          key: 'accion',
          class: 'text-center',
          label: this.$t('vehicleType.table.action'),
          ...common,
        },
      ];
    },
    vehicleField() {
      const common = {
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('vehicle.table.fields.name'),
          ...common,
        },
        {
          key: 'plate',
          label: this.$t('vehicle.table.fields.plate'),
          ...common,
        },
        {
          key: 'fleet',
          label: this.$t('vehicle.table.fields.fleet'),
          ...common,
        },
        {
          key: 'driver',
          label: this.$t('vehicle.table.fields.driver'),
          ...common,
        },
        // {
        //   key: 'groupDesc',
        //   label: this.$t('vehicle.table.fields.group'),
        //   ...common,
        // },
        {
          key: 'valueEnable',
          label: this.$t('vehicle.crud.enabledLastmile'),
          ...common,
        },
        {
          key: 'accion',
          label: this.$t('vehicle.table.fields.actions'),
          class: 'text-center',
        },
      ];
    },
    canPerformMovement() {
      return hasPermission('COR:vehicle:move', this.$store);
    },
    info() {
      return {
        title: 'Vehículos',
        subtitle: 'Agregue vehículos de forma rápida',
        fileNameBasis: 'core_vehicles',
      };
    },
    infoModify() {
      return {
        title: 'Vehículos',
        subtitle: 'Modifique vehículos de forma rápida',
        fileNameBasis: 'core_vehicles',
      };
    },
    filteredType() {
      this.update;
      return this.keywordType
        ? this.vehicletypes.filter((item) => item.name.toUpperCase().includes(this.keywordType.toUpperCase()))
        : this.vehicletypes;
    },
    filtered() {
      this.filterFleets = [];
      this.vehiclesFilter = this.vehicles;

      for (const vehicleFilter of this.vehiclesFilter) {
        for (const dV of this.driverVehicle) {
          if (
            vehicleFilter.id === dV.idVehicle[0] &&
            this.drivers.find((driver) => dV.idDriver === driver.id) !== undefined
          ) {
            vehicleFilter.driver = this.drivers.find((driver) => dV.idDriver === driver.id).username;
          }
        }
      }

      for (const fleet of this.selectedType) {
        this.filterFleets.push(fleet.id);
      }
      this.filterGroups = [];
      for (const group of this.gruposSeleccionados) {
        this.filterGroups.push(group.id);
      }
      if (
        (this.keyword !== null && this.keyword !== '') ||
        this.filterFleets.length > 0 ||
        this.filterGroups.length > 0
      ) {
        this.isFilterApplied = true;
        this.vehiclesFilter = this.vehicles
          .filter((item) => {
            if (item.plate && item.plate.toUpperCase().includes(this.keyword.toUpperCase())) {
              return item;
            }
            if (item.name && item.name.toUpperCase().includes(this.keyword.toUpperCase())) {
              return item;
            }
          })
          .filter(
            (item) =>
              (item.vehicleTypeExtra && this.filterFleets.includes(item.vehicleTypeExtra.id)) ||
              this.filterFleets.length === 0,
          )
          .filter((item) => this.filterGroups.includes(item.group.id) || this.filterGroups.length === 0);
        return this.vehiclesFilter;
      } else {
        this.isFilterApplied = false;
        return this.vehiclesFilter;
      }
    },
    rows() {
      return this.vehiclesFilter.length;
    },
    rowsType() {
      return this.vehicletypes.length;
    },
  },
  watch: {
    temporalSpotRequired: function () {
      if (this.temporalSpotRequired) {
        this.cleanSpotForm();
        this.spotTypeSelected = null;
        this.showModal('create-temporal-spot-modal');
        this.isTemporalSpotBusy = false;
        this.temporalSpotRequired = false;
      }
    },
    '$store.getters.isUserReady': function () {
      this.prepareData();
    },
  },
};
